import React from 'react';
import { Loader2, Check } from 'lucide-react';

/** Full-width navy pill that shrinks to a navy circle while loading and shows a white tick on success. */
export default function MorphButton({ loading, success, onClick, type = 'button', disabled, className = '', children }) {
  const round = loading || success;
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={round || disabled}
      className={`mx-auto h-12 text-white rounded-full text-base font-semibold transition-all duration-500 ease-out hover:opacity-90 disabled:opacity-100 flex items-center justify-center bg-brand-navy-deep ${round ? 'w-12' : 'w-full'} ${className}`}
    >
      {success ? <Check className="w-6 h-6 animate-pop" strokeWidth={3} /> : loading ? <Loader2 className="w-5 h-5 animate-spin" /> : children}
    </button>
  );
}